import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const AboutContainer = ()=>{

    return (
        <>
            <Container>
                <Row>
                    <Col className='pd50'>
                        <p>About Page</p>
                        <h3>
                        Hello Every one thanks for visiting my website, Welcome by Sumit Lakum
                          

                        </h3>
                    

                        <h4>
                        Name: Lakum Sumit
                       
                        </h4>
                        <h4>
                        Contact: +917016661230
                       
                        </h4> <h4>
                        CSE student at GECR ,CS'24❤️
                       
                        </h4>

                       
                    
               

                        

                        


                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default AboutContainer;